import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/item-box.scss";

export const ItemBox = ({ denominator, info, number }) => (
  <div className={ styles.container }>
    <div className={ styles.text }>
      { numberSize(number) }
      { renderDenominator(denominator) }
      <div>{ info }</div>
    </div>
  </div>
);

ItemBox.propTypes = {
  denominator: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  info: PropTypes.string.isRequired,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

const renderDenominator = (denominator) => {
  if (denominator) {
    return <span className={ styles.denominator }> / { denominator }</span>;
  }
  return null;
};

const numberSize = (number) => {
  if (number.length > 5) {
    return <h1 className={ styles.small }>{ number }</h1>;
  }
  return <h1>{ number }</h1>;
};



// WEBPACK FOOTER //
// ./src/js/components/common/item-box.jsx